import React, { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames';
import { Tooltip } from '@/components';
import s from './index.less';
import './index.less';
import { AbstractTooltipProps } from 'antd/es/tooltip';
export interface ActionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  tooltip?: string;
  bottomTitle?: string;
  tooltipConfig?: AbstractTooltipProps;
  order?: number;
}
const ActionBtnPc: React.FC<ActionProps> = ({
  children,
  tooltip,
  title,
  className,
  tooltipConfig,
  ...rest
}) => {
  if (!tooltip) {
    return (
      <div className={classnames(s.actionBtn, className)} {...rest}>
        <div className={s.btnWrap}>{children}</div>
        <span className={s.title}>{title}</span>
      </div>
    );
  }
  return (
    <Tooltip
      align={{ offset: [32, -12] }}
      placement="bottom"
      zIndex={2000}
      title={tooltip}
      {...tooltipConfig}
      className={s.tooltip}
    >
      <div className={classnames(s.actionBtn, className)} {...rest}>
        <div className={s.btnWrap}>{children}</div>
        <span className={s.title}>{title}</span>
      </div>
    </Tooltip>
  );
};
export default ActionBtnPc;
